import { withStyles, Card } from 'vopay';
import { useHistory, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { MaterialSymbol } from '#shared/components/UI';
import { SettingsCardImgsMap } from '../SettingsCard/SettingsCardImg';
import { SettingsItem } from '../types';
import styles from './SettingsSideMenu.module.scss';

const cn = withStyles(styles);

type SettingsSideMenuProps = {
  basePath: string;
  isOverview: boolean;
  items: SettingsItem[];
  onSelectItem: (item: SettingsItem) => void;
};

export default function SettingsSideMenu({ basePath, isOverview, items, onSelectItem }: SettingsSideMenuProps) {
  const history = useHistory();
  const { pathname } = useLocation();
  const { t } = useTranslation('translations', { keyPrefix: 'Shared.Settings.SideMenu' });

  return (
    <Card className={cn('card')}>
      <button type="button" className={cn('item', isOverview && 'active')} onClick={() => history.push(basePath)}>
        <img className={cn('icon')} src={SettingsCardImgsMap.settings.src} alt="" />

        <span className={cn('label')}>{t('overview', { defaultValue: 'Overview' })}</span>
      </button>

      {items.map((item) => {
        const isActive = pathname.startsWith(item.path);

        return (
          <button
            key={item.id}
            type="button"
            className={cn('item', isActive && 'active')}
            onClick={() => onSelectItem(item)}
          >
            <img className={cn('icon')} src={SettingsCardImgsMap[item.icon].src} alt="" />

            <span className={cn('label')}>{item.title}</span>
            {item.isLocked && <MaterialSymbol icon="lock" size="20px" color="rgba(45, 45, 45, 0.6)" />}
          </button>
        );
      })}
    </Card>
  );
}
